import { generateUtilityClasses } from '@mui/material';

export const radioItemClasses = generateUtilityClasses('RadioItem', [
  'root',
  'radio',
  'label',
  'valueRow',
  'textGroup',
  'text',
  'subText',
  'status',
  'statusWrapper',
  'infoButton',
]);
